<template>
  <div>
    <h5>Upload record config</h5>
    <div class="upload-record-config__wrapper">
      <input-widget
        v-for="field in getCurrentFieldsByFileType"
        :id="`inner-configurations-${field.name}`"
        :model="getCurrentModel"
        :field="field"
      />
    </div>
  </div>
</template>

<script>
import {fileManipulationMixin} from '@/modules/FileManipulationController/file-manipulation.mixin';
import InputWidget from '@/core/components/complex-table/components/InputWidget.vue';
import {createNamespacedHelpers} from 'vuex';

const {
  mapState: fileManipulationMapState,
} = createNamespacedHelpers('fileManipulationController');

export default {
  name: 'InnerConfigurations',
  mixins:[fileManipulationMixin],
  components:{InputWidget},
  props:['currentFileType', 'form'],
  computed: {
    ...fileManipulationMapState({
      formFromStore: state => state.formFromStore,
    }),
    getCurrentModel() {
      if(this.formFromStore.batchFileType === 'excel' && this.formFromStore.useBulkUpload) {
        return this.formFromStore.bulkInnerConfig;
      }
      return this.formFromStore.innerConfig;
    },
    getCurrentFieldsByFileType() {
      const form = this.formFromStore;
      if(form.batchFileType === 'flatFile') {
        return this.flatFileExcelFieldsInnerConfig;
      }
      if(form.batchFileType === 'bulkFlatFile') {
        return this.bulkFieldsInnerConfig;
      }
      if(form.batchFileType === 'excel') {
        if(form.useBulkUpload) {
          return this.bulkFieldsInnerConfig;
        }
        return this.flatFileExcelFieldsInnerConfig;
      }
    },
  },
};
</script>